import React, {useContext, useEffect} from 'react'

import Context from './context.jsx'

import {reverseGeocode} from '../../assets/functions/reverseGeocode.js'
import useGeolocation from '../../hooks/useGeolocation.jsx'
import states from '../../assets/states.json'

export default function LocationPage() {
  const {
    selectedState,
    setSelectedState,
    authenticityToken,
    history,
    initialPathname,
    buttonTextColor,
    age,
  } = useContext(Context)

  const geoPosition = useGeolocation()

  // When geolocation updates call for reverseGeocode
  // Only if not already a selectedState
  // If selectedState is updated while reverseGeocode is in progress, the reverseGeocode request will be aborted
  useEffect(() => {
    if (!geoPosition || selectedState) return

    const controller = new AbortController()

    reverseGeocode(geoPosition, authenticityToken, controller.signal)
      .then((regionState) => {
        if (!regionState) return
        setSelectedState(regionState)
        if (age === 'atLeast21') history.push(initialPathname)
      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.error(error)
      })

    return () => controller.abort()
  }, [geoPosition, selectedState])

  function changeSelectedState(regionState) {
    if (selectedState) history.push('/')
    else history.push(initialPathname)
    setSelectedState(regionState)
  }

  return (
    <div className='container w-full lgplus:w-3/5 mx-auto py-24 px-4 text-center'>
      <h1 className='mb-4 text-3xl md:text-4xl font-bold'>Where are you?</h1>

      <div className='mx-auto'>
        {states.map((state) => {
          return (
            <button
              key={`state_${state.abbreviation}`}
              className={`px-2 py-1.5 m-1 border border-light rounded-full hover:bg-primary hover:border-primary hover:shadow hover:${buttonTextColor} ${
                String(selectedState.abbreviation).toLowerCase() ===
                state.abbreviation.toLowerCase()
                  ? `border-primary bg-primary ${buttonTextColor}`
                  : 'text-dark'
              }`}
              onClick={() => changeSelectedState(state)}>
              {state.name}
            </button>
          )
        })}
      </div>

      {[
        'deniedGeolocation',
        'geolocationTimeout',
        'geolocationNotSupported',
        'error',
      ].includes(geoPosition) ? (
        <p className='inline-block md:w-1/3 mt-4 text-red-600'>
          Please enable location for an improved experience. We do not collect
          nor sell any user data.
        </p>
      ) : (
        <></>
      )}
    </div>
  )
}
